export default {
  HTTP_422: 422,
};
